import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ShopRoutingModule} from './shop-routing.module';
import {SharedModule} from '../shared/shared.module';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import {BarRatingModule} from 'ngx-bar-rating';
import {RangeSliderModule} from 'ngx-rangeslider-component';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {NgxPayPalModule} from 'ngx-paypal';
import {NgxImgZoomModule} from 'ngx-img-zoom';
import {HomeFourComponent} from './home-4/home-four.component';
import {SliderComponent} from './home-4/slider/slider.component';
import {ProductSliderFourComponent} from './home-4/product-slider/product-slider.component';
import {SpecialProductsComponent} from './home-4/special-products/special-products.component';
import {ProductComponent} from './product/product.component';
import {ProductBoxComponent} from './product/product-box/product-box.component';
import {ProductBoxHoverComponent} from './product/product-box-hover/product-box-hover.component';
import {ProductBoxVerticalComponent} from './product/product-box-vertical/product-box-vertical.component';
import {ProductBoxMetroComponent} from './product/product-box-metro/product-box-metro.component';
import {CollectionLeftSidebarComponent} from './product/collection/collection-left-sidebar/collection-left-sidebar.component';
import {CollectionRightSidebarComponent} from './product/collection/collection-right-sidebar/collection-right-sidebar.component';
import {CollectionNoSidebarComponent} from './product/collection/collection-no-sidebar/collection-no-sidebar.component';
import {BrandComponent} from './product/collection/filter/brand/brand.component';
import {ProductLeftSidebarComponent} from './product/product-details/product-left-sidebar/product-left-sidebar.component';
import {ProductRightSidebarComponent} from './product/product-details/product-right-sidebar/product-right-sidebar.component';
import {ProductNoSidebarComponent} from './product/product-details/product-no-sidebar/product-no-sidebar.component';
import {ProductColLeftComponent} from './product/product-details/product-col-left/product-col-left.component';
import {ProductColRightComponent} from './product/product-details/product-col-right/product-col-right.component';
import {ProductColumnComponent} from './product/product-details/product-column/product-column.component';
import {ProductAccordianComponent} from './product/product-details/product-accordian/product-accordian.component';
import {ProductLeftImageComponent} from './product/product-details/product-left-image/product-left-image.component';
import {ProductRightImageComponent} from './product/product-details/product-right-image/product-right-image.component';
import {ProductVerticalTabComponent} from './product/product-details/product-vertical-tab/product-vertical-tab.component';
import {RelatedProductsComponent} from './product/product-details/related-products/related-products.component';
import {SidebarComponent} from './product/product-details/sidebar/sidebar.component';
import {CategoriesComponent} from './product/widgets/categories/categories.component';
import {QuickViewComponent} from './product/widgets/quick-view/quick-view.component';
import {ModalCartComponent} from './product/widgets/modal-cart/modal-cart.component';
import {NewProductComponent} from './product/widgets/new-product/new-product.component';
import {CartComponent} from './product/cart/cart.component';
import {CheckoutComponent} from './product/checkout/checkout.component';
import {SuccessComponent} from './product/success/success.component';
import {ExitPopupComponent} from './product/widgets/exit-popup/exit-popup.component';
import {AgeVerificationComponent} from './product/widgets/age-verification/age-verification.component';
import {NewsletterComponent} from './product/widgets/newsletter/newsletter.component';
import {MaterialModule} from '../shared/material.module';
import {ProductCardComponent} from './product/product-card/product-card.component';
import {MercadoPagoComponent} from './product/mercado-pago/mercado-pago.component';
import { SearchComponent } from './home-4/search/search.component';

@NgModule({
    exports: [ExitPopupComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ShopRoutingModule,
        SharedModule,
        MaterialModule,
        SlickCarouselModule,
        BarRatingModule,
        RangeSliderModule,
        InfiniteScrollModule,
        NgxPayPalModule,
        NgxImgZoomModule
    ],
    declarations: [
        HomeFourComponent,
        ProductSliderFourComponent,
        SpecialProductsComponent,
        SliderComponent,
        // Product
        ProductComponent,
        ProductBoxComponent,
        ProductBoxHoverComponent,
        ProductBoxVerticalComponent,
        ProductBoxMetroComponent,
        CollectionLeftSidebarComponent,
        CollectionRightSidebarComponent,
        CollectionNoSidebarComponent,
        BrandComponent,
        ProductLeftSidebarComponent,
        ProductRightSidebarComponent,
        ProductNoSidebarComponent,
        ProductColLeftComponent,
        ProductColRightComponent,
        ProductColumnComponent,
        ProductAccordianComponent,
        ProductLeftImageComponent,
        ProductRightImageComponent,
        ProductVerticalTabComponent,
        RelatedProductsComponent,
        SidebarComponent,
        CategoriesComponent,
        QuickViewComponent,
        ModalCartComponent,
        NewProductComponent,
        CartComponent,
        CheckoutComponent,
        SuccessComponent,
        ExitPopupComponent,
        AgeVerificationComponent,
        NewsletterComponent,
        ProductCardComponent,
        MercadoPagoComponent,
        SearchComponent
    ]
})
export class ShopModule {
}
